import { makeAutoObservable } from 'mobx';
import {BenefitClass} from 'main/stores/benefits';

class EnrolmentViewModel {
  enrolment;
  oldBenefitClass;

  constructor(enrolment) {
    makeAutoObservable(this);

    this.enrolment = enrolment;
    this.oldBenefitClass = new BenefitClass(enrolment.benefitClass);
  }

  updateBenefitClass(benefitClass) {
    this.enrolment.merge({benefitClass, changeEffectiveDate: new Date()});
  }

  get enrolmentChanged() {
    return this.oldBenefitClass.id !== this.enrolment.benefitClass.id;
  }
}

export default EnrolmentViewModel;
